import React, { ChangeEvent, useRef } from 'react'
import uniqueId from 'lodash/uniqueId'

import { CircularProgress } from '@material-ui/core'
import { IOSSwitch } from './IOSSwitch'

import { useBoolState } from '../hooks/commonHooks'
import { useMessages } from '../hooks/snackbarHooks'

export type StoreMultiProductSwitchProps = {
  allowMultiProducts: boolean

  setMultiProducts: (allow: boolean) => Promise<void>
}

export const StoreMultiProductSwitch =
  ({allowMultiProducts, setMultiProducts}: StoreMultiProductSwitchProps) => {
    const {showSuccess, showError} = useMessages()
    const [isSubmitting, setSubmitting, setFinished] = useBoolState()

    const switchName = useRef(uniqueId('StoreMultiProductSwitch_')).current

    const onAllowMultiChange =
      async ({target: {checked: allow}}: ChangeEvent<HTMLInputElement>) => {
        setSubmitting()

        try {
          await setMultiProducts(allow)
          showSuccess(allow ? 'Разрешено' : 'Запрещено')
        } catch (e) {
          console.log('Failed to toggle multi products', e)
          showError('Ошибка при сохранении')
        } finally {
          setFinished()
        }
      }

    return isSubmitting
           ? <CircularProgress size={19}/>
           : <IOSSwitch
             checked={allowMultiProducts}
             onChange={onAllowMultiChange}
             name={switchName}
             color="primary"
           />
  }